import { Skeleton } from "@aurem/ui";
import { useTranslations } from "../i18n";
import type { QueryToolbarProps } from "./types";

export const LoadingState = ({ actions }: QueryToolbarProps) => {
  const { t } = useTranslations();

  return (
    <nav
      className="flex items-center gap-2"
      aria-busy="true"
      aria-label={t("components.queryToolbar.ariaQueryToolbar")}
    >
      <span role="status" className="sr-only">
        {t("components.queryToolbar.loading")}
      </span>

      <Skeleton
        className="shrink-0 w-full max-w-[230px] xl:max-w-[320px] h-10 rounded-xl"
        aria-hidden="true"
      />
      {actions && (
        <Skeleton
          className="w-full max-w-[120px] h-10 rounded-xl ms-auto"
          aria-hidden="true"
        />
      )}
    </nav>
  );
};
